export const INVOICE_FIELD_ORDER = [
  "invoice_number",
  "mirage_invoice_number",
  "invoice_date",
  "due_date",
  "payment_terms",
  "message_type",
  "additional_remarks",
  "notes"
] as const

export const VENDOR_FIELD_ORDER = [
  "vendor_name",
  "vendor_address",
  "vendor_tax_id",
  "vendor_country",
  "vendor_email",
  "vendor_phone"
] as const

export const CUSTOMER_FIELD_ORDER = [
  "customer_name",
  "customer_address",
  "customer_tax_id",
  "customer_country"
] as const

export const PAYMENT_TERMS_OPTIONS = [
  { label: "По банков път", value: "По банков път" },
  { label: "В брой", value: "В брой" }
] as const
